module.exports = __webpack_public_path__ + "static/media/managersIcon.d7d46c9e.svg";